<template>
  <b-modal v-model="modal_banner.mostrar"
           title="Subir imagen"
           size="xl"
           hide-footer
           hide-header
           centered
           modal-class="banner-empresas"
  >

  <b-carousel
      ref="myCarousel"
      id="carousel-fade"
      style="text-shadow: 0px 0px 2px #000"
      fade
      img-width="1024"
      img-height="480"
       no-animation
    >

      <b-carousel-slide
        :caption="imageBannerActive ? imageBannerActive.name : ''"
        :img-src="imageBannerActive ? imageBannerActive.image : ''"
      ></b-carousel-slide>

      <button
        @click="prev()"
        v-b-tooltip.hover
        title="Descargar"
        class="btn btn-secondary btn-left btn-lg"
      >
        <i class="fa fa-arrow-left"></i>
      </button>
      <button 
        @click="next()"
        v-b-tooltip.hover
        title="Descargar"
        class="btn btn-secondary btn-right btn-lg"
      >
        <i class="fa fa-arrow-right"></i>
      </button>

      <button 
        @click="descargarImagen({ 
          id: imageBannerActive.id,
          id_empresa: imageBannerActive.companyId,
          nombre_original: imageBannerActive.name,
        })"
        v-b-tooltip.hover
        title="Descargar"
        class="btn btn-primary boton-descarga btn-lg"
      >
        <i class="fa fa-download"></i>
      </button>
    </b-carousel>
    
  </b-modal>
</template>

<script>

import { mapActions, mapState, mapMutations } from "vuex";
import Swal from 'sweetalert2';

export default {
  name: "modal_banner",
  computed: {
    ...mapState('banners', [
      'modal_banner',
      'imagenes_banner',
      'imageBannerActive'
    ])
  },
  methods: {
    ...mapActions('banners', ['descargarImagen', 'bannerDetailsById']),
    ...mapMutations('banners', ['setImageBannerActive']),
    prev() {
      this.changeBanner(false);
    },
    next() {
      this.changeBanner(true);
    },
    changeBanner(action = true) {

      if (this.imagenes_banner.length <= 0 || this.imagenes_banner == null || this.imagenes_banner == undefined) {
        this.setImageBannerActive(null);
        this.lastBannerShowAlert();
        return false;
      }

      this.imagenes_banner.find((x, index) => {
        if (x.id == this.imageBannerActive.id) {

          const newIndex = action ? index + 1 : index - 1;

          // verificar el hay mas banners
          if (newIndex < 0) {
            this.lastBannerShowAlert()
            return false;
          }
          if (newIndex > this.imagenes_banner.length) {
            this.lastBannerShowAlert()
            return false;
          }

          // obtaner el anterior o proximo banner
          const banner = this.imagenes_banner[newIndex];
          if(banner == null || banner == undefined || !'id' in banner) {
            this.lastBannerShowAlert()
            return false;
          }

          this.bannerDetailsById({
            companyId: x.id_empresa,
            bannerId: banner.id
          });
        }
      });
    },
    lastBannerShowAlert() {
      Swal.fire({
        position: 'center',
        icon: 'info',
        title: 'Banners',
        text: 'No hay mas banners disponibles.',
        showConfirmButton: true,
        timer: 10000
      });
    }
  }
};
</script>

<style>

.img-banner {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
  margin: auto;
}

.banner-empresas .modal-body {
  padding: 0px !important;
}

.carousel-empresas .el-carousel__container {
  width: 100% !important;
  margin: 0px !important;
}

.carousel-empresas .el-carousel__item {
  background-color: #fff;
}

.boton-descarga {
  position: absolute;
  border-radius: 50%;
  right: 30px;
  bottom: 30px;
}

.btn-left{
  position: absolute;
  border-radius: 50%;
  background-color: #f8f8f8;
  left: 1%;
  top: 46%;
  border: 0px;
  box-shadow: 0 2px 18px -3px #ccc;
}

.btn-right{
  position: absolute;
  border-radius: 50%;
  background-color: #f8f8f8;
  right: 1%;
  top: 46%;
  border: 0px;
  box-shadow: 0 2px 18px -3px #ccc;
}

</style>
